"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useHeaders = exports.HeadersProvider = exports.HeadersContext = void 0;
var _react = require("react");
var _utils = require("../utils");
var _userSegmentationDataContext = require("./userSegmentationDataContext");
var _jsxRuntime = require("react/jsx-runtime");
const HeadersContext = exports.HeadersContext = /*#__PURE__*/(0, _react.createContext)({
  loading: true,
  headers: {}
});
const HeadersProvider = ({
  children,
  atpClusterId: atpClusterIdParam,
  customerId,
  customerTypeId: customerTypeIdParam,
  language,
  skipUserSegmentationFetching,
  sourceAppName,
  tenant,
  token,
  useProductDataCaching,
  useProductsService,
  visitorSegment: visitorSegmentParam
}) => {
  const userSegmentationData = (0, _userSegmentationDataContext.useUserSegmentationData)();
  const atpClusterId = userSegmentationData.atpClusterId ?? atpClusterIdParam;
  const customerTypeId = userSegmentationData.customerTypeId ?? customerTypeIdParam;
  const visitorSegment = userSegmentationData.visitorSegment ?? visitorSegmentParam;
  const value = (0, _react.useMemo)(() => ({
    headers: (0, _utils.getHeaders)({
      atpClusterId,
      customerId,
      customerTypeId,
      language,
      sourceAppName,
      tenant,
      token,
      useProductDataCaching,
      useProductsService,
      visitorSegment
    }),
    loading: !skipUserSegmentationFetching && userSegmentationData.loading
  }), [atpClusterId, customerId, customerTypeId, language, skipUserSegmentationFetching, sourceAppName, tenant, token, useProductDataCaching, useProductsService, userSegmentationData.loading, visitorSegment]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(HeadersContext.Provider, {
    value: value,
    children: children
  });
};
exports.HeadersProvider = HeadersProvider;
const useHeaders = () => (0, _react.useContext)(HeadersContext);
exports.useHeaders = useHeaders;
//# sourceMappingURL=headersContext.js.map